import { ParamsNames } from "./paramsNames";

// Helper function to build routes with locale and organization code
const withLocaleAndOrg = (path: string) => `/:${ParamsNames.LOCALE}/organization/:${ParamsNames.ORGANIZATION_CODE}${path}`;
// Helper function to build routes without locale and organization code (for backward compatibility)
const withoutLocaleAndOrg = (path: string) => path;

export const RouteNames = {
  home: withLocaleAndOrg("/"),
  homeWithoutOrg: withoutLocaleAndOrg("/"),
  login: "/login",
  site: withLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}`),
  siteWithoutOrg: withoutLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}`),
  outdoorAreas: withLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}/outdoor-areas`),
  outdoorAreasWithoutOrg: withoutLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}/outdoor-areas`),
  building: withLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}/buildings/:${ParamsNames.BUILDING_ID}`),
  buildingWithoutOrg: withoutLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}/buildings/:${ParamsNames.BUILDING_ID}`),
  floor: withLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}/buildings/:${ParamsNames.BUILDING_ID}/floors/:${ParamsNames.FLOOR_ID}`),
  floorWithoutOrg: withoutLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}/buildings/:${ParamsNames.BUILDING_ID}/floors/:${ParamsNames.FLOOR_ID}`),
  annotations: withLocaleAndOrg("/annotations"),
  annotationsWithoutOrg: withoutLocaleAndOrg("/annotations"),
  siteAnnotations: withLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}/annotations`),
  siteAnnotationsWithoutOrg: withoutLocaleAndOrg(`/sites/:${ParamsNames.SITE_ID}/annotations`),
  annotationFilters: withLocaleAndOrg("/annotations/filters"),
  annotationFiltersWithoutOrg: withoutLocaleAndOrg("/annotations/filters"),
  notFound: "/404",
  errorPage404: "/error",
  errorPage500: "/error",
};

// Helper function to build URLs with locale and organization code
const buildWithLocaleAndOrg = (locale: string | null | undefined, organizationCode: string | null | undefined, path: string) => {
  if (locale && organizationCode) {
    return `/${locale}/organization/${organizationCode}${path}`;
  }
  return path;
};

export const RouteBuilder = {
  site: (siteId: string, locale?: string | null, organizationCode?: string | null) => 
    buildWithLocaleAndOrg(locale, organizationCode, `/sites/${siteId}`),
  building: (siteId: string, buildingId: string, locale?: string | null, organizationCode?: string | null) => 
    buildWithLocaleAndOrg(locale, organizationCode, `/sites/${siteId}/buildings/${buildingId}`),
  floor: (siteId: string, buildingId: string, floorId: string, locale?: string | null, organizationCode?: string | null) =>
    buildWithLocaleAndOrg(locale, organizationCode, `/sites/${siteId}/buildings/${buildingId}/floors/${floorId}`),
  outdoorAreas: (siteId: string, locale?: string | null, organizationCode?: string | null) => 
    buildWithLocaleAndOrg(locale, organizationCode, `/sites/${siteId}/outdoor-areas`),
  annotations: (locale?: string | null, organizationCode?: string | null) => 
    buildWithLocaleAndOrg(locale, organizationCode, "/annotations"),
  siteAnnotations: (siteId: string, locale?: string | null, organizationCode?: string | null) => 
    buildWithLocaleAndOrg(locale, organizationCode, `/sites/${siteId}/annotations`),
  annotationFilters: (locale?: string | null, organizationCode?: string | null) => 
    buildWithLocaleAndOrg(locale, organizationCode, "/annotations/filters"),
  home: (locale?: string | null, organizationCode?: string | null) => 
    buildWithLocaleAndOrg(locale, organizationCode, "/"),
};
